<template>
  <v-navigation-drawer fixed temporary v-model="inputValue" left>
    <v-list>
      <v-list-tile>
        <v-spacer />
        <v-btn icon @click="toggleDrawer">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-tile>
      <v-list-tile v-for="(item, i) in items" :key="i" :to="item.to">
        <v-list-tile-title v-text="item.text" />
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-title @click="toggleDrawer" v-scroll-to="'#hours'">
          Hours
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-title @click="toggleDrawer" v-scroll-to="'#location'">
          Location
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="toggleDrawer, call()">
        <v-list-tile-title>
          Call
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations } from 'vuex'

export default {
 computed: {
  inputValue: {
   get() {
    return this.$store.state.app.drawer
   },
   set(val) {
    this.setDrawer(val)
   },
  },
  items() {
   return [
    {
     text: this.$t('Layout.Drawer.home'),
     to: '/home',
    },
    {
     text: this.$t('Layout.Drawer.about'),
     to: '/about',
    },
    {
     text: this.$t('Layout.Drawer.pricing'),
     to: '/pricing',
    },
    {
     text: this.$t('Layout.Drawer.contact'),
     to: '/contact',
    },
    {
     text: 'Cut Sheets',
     to: '/cutsheets',
    },
   ]
  },
 },

 methods: {
  call() {
   window.open('tel:+1-208-888-9690')
  },
  ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
 },
}
</script>
